import React, { useState, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { Avatar } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import LogoutModal from "../../components/modals/LogoutModal";

import EditIcon from "@mui/icons-material/Edit";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PaymentIcon from "@mui/icons-material/Payment";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const AccountOptionsDrowdown = ({ account }) => {
  const { user } = useContext(AuthContext);
  const [logoutmodal, setlogoutmodal] = useState(false);

  const CloseLogoutModal = () => {
    setlogoutmodal(false);
  };

  return (
    <>
      <style>
        {`
        .account-dropdown-menu {
          width: 250px;
          border-radius: 14px;
          padding: 8px;
          box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.06);
          background: #ffffff;
          margin-top: 10px !important;
          animation: dropdownFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
        }

        @keyframes dropdownFadeIn {
          from {
            opacity: 0;
            transform: translateY(4px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .account-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          border-radius: 10px;
          background: #f9fafb;
          margin-bottom: 6px;
          border: 1px solid rgba(0, 0, 0, 0.03);
        }

        .account-name {
          font-weight: 600;
          font-size: 13.5px;
          color: #111827;
          letter-spacing: -0.01em;
        }

        .account-status {
          font-size: 11px;
          color: #10b981;
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: 500;
        }

        .account-status::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #10b981;
        }

        .account-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          color: #374151;
          font-weight: 500;
          font-size: 13px;
          transition: all 0.15s ease;
        }

        .account-item svg {
          font-size: 18px;
          color: #6b7280;
          transition: color 0.15s ease;
        }

        .account-item:hover {
          background: #f3f4f6;
          color: #111827;
        }

        .account-item:hover svg {
          color: #111827;
        }

        .account-divider {
          height: 1px;
          background: #f3f4f6;
          margin: 4px 0;
        }

        .dropdown-toggle::after {
          display: none !important;
        }
        `}
      </style>

      <LogoutModal visibility={logoutmodal} HandleClose={CloseLogoutModal} />

      <Dropdown align="end">
        <Dropdown.Toggle className="bg-transparent border-0 p-0">
          <Avatar
            src={
              account && account.profile_pic
                ? account.profile_pic
                : null
            }
          />
        </Dropdown.Toggle>

        <Dropdown.Menu className="account-dropdown-menu">
          <div className="account-header">
            <Avatar
              src={
                account && account.profile_pic
                  ? account.profile_pic
                  : null
              }
            />
            <div>
              <div className="account-name">
                {account && account.username
                  ? account.username
                  : "Guest"}
              </div>
              <div className="account-status">Online</div>
            </div>
          </div>

          <Link to={`/u/${account && account.username}`} className="text-decoration-none">
            <div className="account-item">
              <AccountCircleIcon /> My Account
            </div>
          </Link>

          <Link to="/edit-profile" className="text-decoration-none">
            <div className="account-item">
              <EditIcon /> Edit Profile
            </div>
          </Link>

          <div className="account-divider"></div>

          <Link to="/wallet" className="text-decoration-none">
            <div className="account-item">
              <AccountBalanceWalletIcon /> Wallet
            </div>
          </Link>

          <Link to="/payments" className="text-decoration-none">
            <div className="account-item">
              <PaymentIcon /> Payments
            </div>
          </Link>

          <div className="account-divider"></div>

          <Link to="/settings" className="text-decoration-none">
            <div className="account-item">
              <SettingsIcon /> Settings
            </div>
          </Link>

          <div
            className="account-item"
            onClick={() => setlogoutmodal(true)}
          >
            <LogoutIcon /> Logout
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default AccountOptionsDrowdown;